import type { HTMLAttributes, Ref } from "react";

import { badge } from "~/components/Badge.css";

export type BadgeVariant =
  | "neutral"
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "navy"
  | "olive";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  /** Semantic color. Defaults to "neutral". */
  variant?: BadgeVariant;
  ref?: Ref<HTMLSpanElement>;
}

/**
 * Inline status chip. Renders a <span> with a tinted surface and
 * matching text color from the same status family. Use for task
 * states, case phases (via dedicated PhaseBadge later), counts, etc.
 */
export function Badge({
  variant = "neutral",
  className,
  ref,
  ...rest
}: BadgeProps) {
  const variantClass = badge[variant];
  const merged =
    className !== undefined && className.length > 0
      ? `${variantClass} ${className}`
      : variantClass;
  return <span ref={ref} className={merged} {...rest} />;
}
